module.exports = __webpack_public_path__ + "img/art_4_5.23ae19b9.png";